import { useState } from 'react';
import { SCAMPER_KEYS } from '@isbd/shared';
import { invokeAiFunction, kuunda } from '@/lib/kuunda';
import { useToast } from '@/features/ui/toast/useToast';

interface Props {
  ideationId: string;
  businessIdea: string;
  onSaved?: (scamper: Record<string, unknown>) => void;
}

export function ScamperPanel({ ideationId, businessIdea, onSaved }: Props) {
  const toast = useToast();
  const [scamper, setScamper] = useState<Record<string, unknown> | null>(null);
  const [loading, setLoading] = useState(false);

  async function run() {
    setLoading(true);
    try {
      const result = await invokeAiFunction<{ scamper: Record<string, unknown> }>('ai-analyze', {
        kind: 'scamper',
        ideation_id: ideationId,
        business_idea: businessIdea,
      });
      const data = result.scamper ?? result;
      setScamper(data);
      const { error: upErr } = await kuunda.from('ideations').update({ scamper: data }).eq('id', ideationId);
      if (upErr) throw upErr;
      toast.success('Analyse SCAMPER enregistrée.', 'SCAMPER');
      onSaved?.(data);
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'SCAMPER impossible');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="panel" style={{ marginTop: '1rem' }}>
      <h3 style={{ marginTop: 0 }}>SCAMPER</h3>
      <p className="muted">Explorer des variantes de l’idée (Substitute, Combine, Adapt…).</p>
      <button type="button" className="btn btn-accent" disabled={loading} onClick={() => void run()}>
        {loading ? 'Analyse Grok…' : 'Lancer SCAMPER'}
      </button>
      {scamper ? (
        <div style={{ marginTop: '1rem', display: 'grid', gap: '0.75rem' }}>
          {SCAMPER_KEYS.map((k) => {
            const block = scamper[k.key] as { idees?: string[]; synthese?: string } | undefined;
            return (
              <div key={k.key}>
                <strong>{k.label}</strong>
                <p className="muted" style={{ margin: '0.2rem 0' }}>
                  {k.prompt}
                </p>
                <ul>
                  {(block?.idees ?? []).map((idea) => (
                    <li key={idea}>{idea}</li>
                  ))}
                </ul>
                {block?.synthese ? <p>{block.synthese}</p> : null}
              </div>
            );
          })}
          {typeof scamper.synthese_globale === 'string' ? (
            <p>
              <strong>Synthèse :</strong> {scamper.synthese_globale}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
